module.exports = __webpack_public_path__ + "static/media/butt04.6e188ef5.png";